import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { LayoutProperties } from "../../../layouts/Layout";
import Reservation from "./Reservation";

export default () =>
  <LayoutProperties horizontalPosition="left" verticalPosition="bottom" fullHeight>
    <Switch>
      <Route path={"/booking/order"}
             component={Reservation} />
      <Redirect to={"/booking/order"} />
    </Switch>
  </LayoutProperties>
